<div class="top">
  <div class="heading">
    <span class="fw-bold">CREATE WORKFLOW</span>
  </div>
  <i class="material-icons text-danger" role="button" (click)="closeModal()">
    close
  </i>
</div>

<div class="form-wrapper">
  <form [formGroup]="form">
    <div class="form-fields">
      <div class="row g-2 gy-3">
        <div class="col-md-6">
          <div class="field">
            <label for="name" class="required">WORKFLOW NAME</label>
            <input
              formControlName="workflowName"
              class="form-control"
              readonly
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="field">
            <label for="name" class="required">LGA</label>
            <input formControlName="lga" class="form-control" readonly />
          </div>
        </div>
        <div class="col-md-12">
          <div class="field">
            <label class="required">DESCRIPTION</label>
            <textarea
              placeholder="description"
              class="form-control"
              formControlName="description"
              readonly
            ></textarea>
          </div>
        </div>

        <fieldset class="border p-3 rounded">
          <legend class="w-auto px-2 text-muted">Workflow Stage</legend>
          <table class="custom-table table-bordered">
            <thead class="custom-table-heading">
              <tr>
                <th class="ps-4">Name</th>
                <th class="ps-4">email</th>
                <th>Stage Number</th>
                <th class="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let stage of stages; let i = index">
                <td>{{ stage?.name }}</td>
                <td>{{ stage?.email }}</td>
                <td>{{ stage?.stageNumber }}</td>
                <td>{{ stage?.onApproved }}</td>
              </tr>
            </tbody>
          </table>
        </fieldset>
      </div>

     

      
    </div>
  </form>
</div>
